import { useEffect, useState } from "react";
import styled from "styled-components";
import media from "styled-media-query";
import { Text, ColorV2, Button } from "@adoptaunabuelo/react-components";
import VideoModal from "../../../components/modal/VideoModal";
import { useSelector } from "react-redux";
import { State } from "../../../redux";
import { Play } from "lucide-react";

const HeaderContainer = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;
const Section = styled.div`
	position: relative;
	display: flex;
	flex-direction: row;
	background: none;
	background-image: none;
	${media.greaterThan("medium")`
		height: auto;
	`}
	${media.lessThan("medium")`
		flex-direction: column;
		margin: 0px -24px;
		height: auto;
		background: none;
		background-image: none;
    `}
`;
const SectionMobile = styled.div`
	position: relative;
	display: none;
	flex-direction: column;
	margin: 4px -24px 0px;
	${media.lessThan("medium")`
        display: flex;
    `}
`;
const MobilePhoto = styled.img`
	display: none;

	${media.lessThan("medium")`
		display: block;
		width: 100%;
		border-radius: 24px;
		margin-bottom: 32px;
	`}
`;
const DesktopColumn = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 700px;
	margin-top: 24px;

	${media.lessThan("medium")`
		display: contents;
		margin-top: 0;
		max-width: none;
	`}
`;
const DesktopPhoto = styled.img`
	display: block;
	width: 100%;
	max-width: 700px;
	border-radius: 24px;
	margin-bottom: 32px;

	${media.lessThan("medium")`
		display: none;
	`}
`;
const DataView = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 700px;
	z-index: 1;
	${media.lessThan("medium")`
		width: unset;
		padding: 0 24px;
		margin-top: 0px;
    `}
`;
const Row = styled.div`
	display: flex;
	flex-direction: row;
`;
const Title = styled(Text)`
	font-weight: 600 !important;
	color: var(--text-clear-neutral-hard, rgba(0, 29, 61, 0.92));
	font-feature-settings: "liga" off, "clig" off;
	font-family: Poppins;
	font-size: 40px !important;
	font-style: normal;
	font-weight: 600 !important;
	line-height: 48px !important;
	letter-spacing: -0.4px;

	${media.lessThan("small")`
		font-feature-settings: "liga" off, "clig" off;
		font-family: Poppins;
		font-size: 28px !important;
		font-style: normal;
		font-weight: 600 !important;
		line-height: 36px !important;
		letter-spacing: -0.28px;
	`}
`;
const TitleSpan = styled.span`
	background-color: white;
	padding: 0px 8px;

	${media.lessThan("medium")`
		background-color: transparent;
		padding: 0;
	`}
`;

const Header = (props: Props) => {
	const isMobile = useSelector((state: State) => state.screen.isMobile);
	const [play, setPlay] = useState(false);

	useEffect(() => {
		if (props.utmSource) {
			if (props.utmSource === "email" || props.utmSource === "whatsapp-sb") {
				const timer = setTimeout(() => {
					setPlay(true);
				}, 1000);
				return () => clearTimeout(timer);
			}
		}
	}, [props.utmSource]);

	const onVideoEnd = () => {
		setPlay(false);
	};

	return (
		<>
			<VideoModal
				isVisible={play}
				url={"https://youtube.com/shorts/Tu7wJvr0vfM"}
				onFinish={onVideoEnd}
				onClose={() => setPlay(false)}
			/>
			<HeaderContainer style={{
				borderBottom: "1px solid " + ColorV2.border.neutralSoft,
				paddingBottom: isMobile ? 48 : 64
			}}>
				<SectionMobile>{props.children}</SectionMobile>
				<Section>
					<MobilePhoto
						alt="Voluntaria y persona mayor sonriendo"
						src={require("../../../assets/images/donation/HeaderDonationPhoto.webp")}
					/>
					<DesktopColumn>
						<DesktopPhoto
							alt="Voluntaria y persona mayor sonriendo"
							src={require("../../../assets/images/donation/HeaderDonationPhotoWeb.webp")}
						/>
						<DataView>
							<Title
								type="h2"
								style={{
									marginBottom: 32,
									lineHeight: isMobile ? "36px" : 1.4,
									letterSpacing: isMobile ? "-0.28px" : undefined,
								}}
							>
								{isMobile ? (
									<>
										Gracias a tu apoyo estamos creando
										<br />
										la mayor fundación de ayuda a personas mayores
									</>
								) : (
									<>
										Gracias a tu apoyo estamos
										<br />
										creando la mayor fundación de
										<br />
										ayuda a personas mayores
									</>
								)}
							</Title>
							<Row>
								{/* <Button
									style={{
										background: "transparent",
										backdropFilter: undefined,
										color: ColorV2.text.neutralHard,
										height: isMobile ? 48 : 56,
										padding: isMobile ? "15px 20px" : "0px 24px",
										fontWeight: 600,
										border: `1px solid ${ColorV2.text.neutralHard}`,
										borderRadius: 999,
									}}
									icon={
										<Play
											height={18}
											width={18}
											fill={"transparent"}
											color={ColorV2.text.neutralHard}
										/>
									}
									onClick={() => setPlay(true)}
								>
									Ver cómo lo hacemos
								</Button> */}
							</Row>
						</DataView>
					</DesktopColumn>
				</Section>
			</HeaderContainer>
		</>
	);
};
export default Header;
export interface Props {
	children?: React.ReactNode;
	utmSource?: string;
}
